module.exports = __webpack_public_path__ + "img/sn-inst-dark.0c91fa4e.svg";